import React from 'react';
import PropTypes from 'prop-types';

const ReturnKey = (props) => {
    const { className, style } = props;
    return (
        <svg className={className} style={style} width="19px" height="19px" viewBox="0 0 19 19">
            <g id="modules" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="rainbow-GlobalSearch"
                    transform="translate(-272.000000, -229.000000)"
                    fillRule="nonzero"
                >
                    <g id="Group-3" transform="translate(146.000000, 213.000000)">
                        <g id="Group-2" transform="translate(0.000000, 1.000000)">
                            <g id="returnKey" transform="translate(126.750000, 15.750000)">
                                <path
                                    d="M16.3295456,0 L1.67021557,0 C0.752396497,0 0,0.748419118 0,1.6830912 L0,16.316394 C0,17.2515609 0.752299262,18 1.67025538,18 L16.3297844,18 C17.247735,18 18,17.2515658 18,16.316394 L18,1.6830912 C18,0.748386801 17.2475333,0 16.3295456,0 Z M1.67021557,0.559738134 L16.3295456,0.559738134 C16.9698884,0.559738134 17.4810319,1.06811016 17.4810319,1.6830912 L17.4810319,16.316394 C17.4810319,16.9318874 16.9700553,17.4402619 16.3297844,17.4402619 L1.67025538,17.4402619 C1.02997486,17.4402619 0.518968134,16.9318772 0.518968134,16.316394 L0.518968134,1.6830912 C0.518968134,1.06812397 1.03005573,0.559738134 1.67021557,0.559738134 Z"
                                    id="Path"
                                    fill="#DDDEE4"
                                />
                                <path
                                    d="M12.0432069,9.68103448 C12.0432069,9.90986207 11.8578276,10.0948276 11.6294138,10.0948276 L8.73286207,10.0948276 L8.73286207,11.3362069 C8.73286207,11.5033793 8.63189655,11.6548276 8.47755172,11.7185517 C8.42624138,11.740069 8.37244828,11.75 8.31906897,11.75 C8.21148276,11.75 8.10555172,11.7077931 8.02651724,11.6287586 L6.37134483,9.97358621 C6.20955172,9.8117931 6.20955172,9.55027586 6.37134483,9.38848276 L8.02651724,7.73331034 C8.14486207,7.61455172 8.32237931,7.57855172 8.47755172,7.64351724 C8.63189655,7.70724138 8.73286207,7.85868966 8.73286207,8.02586207 L8.73286207,9.26724138 L11.2156207,9.26724138 L11.2156207,6.1637931 C11.2156207,5.93496552 11.401,5.75 11.6294138,5.75 C11.8578276,5.75 12.0432069,5.93496552 12.0432069,6.1637931 L12.0432069,9.68103448 Z"
                                    id="Path"
                                    fill="#777B89"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

ReturnKey.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
};

ReturnKey.defaultProps = {
    className: undefined,
    style: undefined,
};

export default ReturnKey;
